// Mirrors $maxNavbarMobileWidth in _navBreakpoints.scss — the width at or below which the
// mobile header replaces the desktop one.
//
// The global MOBILE_WIDTH behind `getIsMobileScreenWidth` is 999, twenty pixels narrower.
// Using that one to decide which header's interactions to run leaves 1000–1019px rendering
// the mobile header while JS still takes the desktop branch.
export const MAX_NAVBAR_MOBILE_WIDTH = 1019
